import { isAutoRead } from '@proton/mail/helpers/location';
import { toMap } from '@proton/shared/lib/helpers/object';
import type { LabelCount } from '@proton/shared/lib/interfaces';

import type { Element } from '../models/element';
import { hasLabel, isUnread as testIsUnread } from './elements';
import type { LabelChanges } from './labels';

export const replaceCounter = (counters: LabelCount[], counter: LabelCount) =>
    counters.map((existingCounter: LabelCount) => {
        if (existingCounter.LabelID === counter.LabelID) {
            return { ...existingCounter, counter };
        }
        return existingCounter;
    });

const fromMapToArray = (countersMap: { [labelID: string]: LabelCount }) =>
    Object.entries(countersMap).map(([, counter]) => counter);

/**
 * @deprecated can be deleted once useOptimisticApplyLabels is deleted
 */
export const updateCounters = (element: Element, counters: LabelCount[], changes: LabelChanges) => {
    const countersMap = Object.entries(changes).reduce(
        (acc, [labelID, action]) => {
            acc[labelID] = { Total: 0, Unread: 0, LabelID: labelID, ...acc[labelID] };

            const isUnread = testIsUnread(element, labelID);

            if (action) {
                acc[labelID].Total = (acc[labelID].Total || 0) + 1;
                if (isUnread && !isAutoRead(labelID)) {
                    acc[labelID].Unread = (acc[labelID].Unread || 0) + 1;
                }
            } else {
                acc[labelID].Total = (acc[labelID].Total || 0) - 1;
                if (isUnread) {
                    acc[labelID].Unread = (acc[labelID].Unread || 0) - 1;
                }
            }

            return acc;
        },
        toMap(counters, 'LabelID')
    );
    return fromMapToArray(countersMap);
};

/**
 * @deprecated can be deleted once useOptimisticApplyLabels is deleted
 */
export const updateCountersForMarkAs = (elementBefore: Element, elementAfter: Element, counters: LabelCount[]) => {
    return counters.map((counter) => {
        if (!hasLabel(elementBefore, counter.LabelID || '')) {
            return counter;
        }

        const unreadBefore = testIsUnread(elementBefore, counter.LabelID);
        const unreadAfter = testIsUnread(elementAfter, counter.LabelID);

        let Unread = counter.Unread || 0;

        if (unreadBefore && !unreadAfter) {
            Unread -= 1;
        }

        if (!unreadBefore && unreadAfter) {
            Unread += 1;
        }

        return { ...counter, Unread };
    });
};
